<template lang="html">
  <div :style="embedContainerStyle" class="embed-container">
    <div v-if="!dataBound" class="mx-auto" style="width: 200px;">
      <b-spinner small label="Loading..." class="mr-2" />Parsing zip file ...
    </div>
    <SoundslidesPlayer
      v-if="dataBound"
      :key="'player_' + zipName"
      ref="editPlayer"
      :editing_initial_slide_data="zipShowModel.slideArray"
      :editing_initial_overlay_data="zipShowModel.overlayArray"
      :editing_initial_settings_data="zipShowModel.displaySettings"
      :editing_audio_source_url="audioUrl"
      :editing_audio_duration="duration"
      :force_preload="true"
      :fillscreen="false"
    />
  </div>
</template>

<script>
import { ZipShow } from "@/models/zipShow";
import JSZip from "jszip";
import JSZipUtils from "jszip-utils";
import SoundslidesPlayer from "@/components/SoundslidesPlayer/SoundslidesPlayer";
export default {
  name: "ZipPlayer",
  components: {
    SoundslidesPlayer
  },
  props: {
    zip: {
      type: File,
      default: () => {}
    },
    zipUrl: {
      type: String,
      default: () => ""
    }
  },
  data() {
    return {
      dataBound: false,
      audioUrl: "",
      duration: 0,
      zipShowModel: {}
    };
  },
  computed: {
    embedContainerStyle() {
      var _style = {};
      var padding =
        100 / (this.zipShowModel.displaySettings || {}).aspectRatio || 66.63;
      _style["padding-bottom"] = padding + "%";
      return _style;
    }
  },
  mounted() {
    if (this.zip) {
      this.loadFromZipFile();
    }
    if (this.zipUrl != "") {
      this.loadFromUrl();
    }
  },
  methods: {
    loadFromZipFile() {
      var _v = this;
      _v.dataBound = false;
      _v.zipName = this.zip.name;

      JSZip.loadAsync(this.zip) // 1) read the Blob
        .then(zip => {
          var _show = new ZipShow(zip);
          return _show.parseZip();
        })
        .then(show => {
          console.log(show);
          if (show.error) {
            _v.$emit("error", show.errorMessage);
            throw show.errorMessage;
          }
          _v.zipShowModel = show;
          return show;
        })
        .then(show => {
          return show.extractFilesToBlobs();
        })
        .then(show => {
          _v.audioUrl = show.audioBlob;
          _v.duration = show.duration;
          _v.dataBound = true;
          if (show.error) {
            console.log("error!", show);
            _v.$emit("error", show.errorMessage);
          } else {
            _v.$emit("loaded", _v.zipShowModel);
          }

          return show;
        })
        .catch(e => {
          console.info(e);
        });
    },
    loadFromUrl() {
      var _v = this;
      _v.dataBound = false;

      new JSZip.external.Promise(function(resolve, reject) {
        JSZipUtils.getBinaryContent(_v.zipUrl, function(err, data) {
          if (err) {
            reject(err);
          } else {
            resolve(data);
          }
        });
      })
        .then(function(data) {
          return JSZip.loadAsync(data);
        })
        .then(zip => {
          var _show = new ZipShow(zip);
          return _show.parseZip();
        })
        .then(show => {
          console.log(show);
          if (show.error) {
            _v.$emit("error", show.errorMessage);
            throw show.errorMessage;
          }
          _v.zipShowModel = show;
          return show;
        })
        .then(show => {
          return show.extractFilesToBlobs();
        })
        .then(show => {
          _v.audioUrl = show.audioBlob;
          _v.duration = show.duration;
          _v.dataBound = true;
          if (show.error) {
            console.log("error!", show);
            _v.$emit("error", show.errorMessage);
          } else {
            _v.$emit("loaded", _v.zipShowModel);
          }

          return show;
        })
        .catch(e => {
          console.info(e);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.embed-container {
  position: relative;
  padding: 0;
  //padding-bottom: 66.63%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
}
</style>
